module.exports = __webpack_public_path__ + "img/GreenTick.d70e2565.svg";